import classNames from "classnames";
import { HTMLProps } from "react";
import React from "react";
import { useTranslation } from "react-i18next";

// components
import Avatar, { AvatarSize } from "../../../components/common/Avatar";
import { UserIdVerifiedIcon } from "../../common/idVerified";
// styles
import styles from "./styles.module.scss";

interface IImageUploaderProps extends HTMLProps<HTMLDivElement> {
  imageUrl?: string;
  imageUploading?: boolean;
  handleOnImageChange?: any;
  showVerification?: boolean;
  nationalIdVerified?: boolean;
}
export const ImageUploader = ({
  imageUploading,
  imageUrl,
  handleOnImageChange,
  showVerification = false,
  nationalIdVerified = false,
}: IImageUploaderProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div id={`image_upload_button`} className={styles["avatar_wrapper"]}>
      {handleOnImageChange && (
        <input
          onChange={handleOnImageChange}
          className={styles["avatar_top"]}
          type="file"
          name="picture"
          accept="image/x-png,image/jpeg,image/jpg,image/webp,image/png"
          id="picture"
        />
      )}
      {imageUploading ? (
        <div className={styles["avatar_loading"]}>
          <p className={classNames(styles["subtitle1"], styles["g900"])}>
            {t("lbl_loading")} ..
          </p>
        </div>
      ) : (
        <Avatar
          avatarSize={AvatarSize.LARGE}
          className={styles["avatar"]}
          src={imageUrl}
          alt="">
          {showVerification && (
            <UserIdVerifiedIcon nationalIdVerified={nationalIdVerified} />
          )}
        </Avatar>
      )}
    </div>
  );
};
